<template>
    <div class="container-fluid py-3">
        <div class="row w-100 d-flex justify-content-between mb-4">
            <div class="col-md-6 d-flex p-0 m-0">
                <router-link class="back-route" @click="backHandler" :to="this.isDataFlag ? '#':'/roles'">
                    <font-awesome-icon :icon="['fas', 'angle-left']" size="lg"/>
                </router-link>
                &nbsp;
                <h3>Edit Role</h3>
            </div>
            <div class="col-md-6 d-flex justify-content-end align-items-center p-0 m-0">
                <div class="buttonSave">
                    <button :class="{notAllowed: isRoleCreatedSuccessfully}" @click.prevent="EditRole">Save</button>
                </div>
            </div>
        </div>

        <div class="dataFill">
            <div class="row w-100">
                <div class="col-md-6 w-100 cssInput">
                    <label>Role Name<span style="color: red;">*</span></label>
                    <input type="text" v-model="role.name" placeholder="Role Name" class="form-control" id="name" @input="checkNumberInInputs">
                    <span class="text-danger" v-if="isErrorNumberExist">{{errorMsg}}</span>
                    <div v-if="errors['name'].length > 0">
                        <div v-for="msg in errors['name']" class="err text-danger position-absolute">{{msg}}
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <br>
            <div class="row">
                <div class="col-md-3">
                    <div class="card cssCardAll">
                        <div class="card-header text-center cssCardHeader">
                            <span>Add</span>
                        </div>
                        <div class="card-body cssCardBody w-100">
                            <div class="d-flex cssInputDiv" v-for="permission in addPermissions" :key="permission.id">
                                <input class="form-check-input" :id="(permission.id)" type="checkbox"  :value="permission.id" v-model="role.permissionsInputs" @change="checkPermissionAdd($event,permission.name)" :checked="selectedRoles.includes(permission.id)">
                                &nbsp;&nbsp;&nbsp;
                                <label class="form-check-label sizeCss" :for="(permission.id)" >
                                    {{capitalizeFirstLetter(permission.name)}}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="card cssCardAll">
                        <div class="card-header text-center cssCardHeader">
                            <span>Edit</span>
                        </div>
                        <div class="card-body cssCardBody w-100">
                            <div class="d-flex cssInputDiv" v-for="permission in editPermissions" :key="permission.id">
                                <input class="form-check-input" :id="(permission.id)" type="checkbox" :value="permission.id" v-model="role.permissionsInputs" @change="checkPermissionEdit($event,permission.name)" :checked="selectedRoles.includes(permission.id)">
                                &nbsp;&nbsp;&nbsp;
                                <label class="form-check-label sizeCss" :for="(permission.id)">
                                    {{capitalizeFirstLetter(permission.name)}}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="card cssCardAll">
                        <div class="card-header text-center cssCardHeader">
                            <span>View</span>
                        </div>
                        <div class="card-body cssCardBody w-100">
                            <div class="d-flex cssInputDiv" v-for="permission in viewPermissions" :key="permission.id">
                                <input class="form-check-input" :id="(permission.id)" type="checkbox" :value="permission.id" v-model="role.permissionsInputs" :checked="selectedRoles.includes(permission.id)">
                                &nbsp;&nbsp;&nbsp;
                                <label class="form-check-label sizeCss" :for="(permission.id)">
                                    {{capitalizeFirstLetter(permission.name)}}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="card cssCardAll">
                        <div class="card-header text-center cssCardHeader">
                            <span>Delete</span>
                        </div>
                        <div class="card-body cssCardBody w-100">
                            <div class="d-flex cssInputDiv" v-for="permission in deletePermissions" :key="permission.id">
                                <input class="form-check-input" :id="(permission.id)" type="checkbox" :value="permission.id" v-model="role.permissionsInputs" @change="checkPermissionDelete($event,permission.name)" :checked="selectedRoles.includes(permission.id)">
                                &nbsp;&nbsp;&nbsp;
                                <label class="form-check-label sizeCss" :for="(permission.id)">
                                    {{capitalizeFirstLetter(permission.name)}}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <AlartModal v-if="showModal" :message="message" :imagePath="ImagePath" @close-modal="showModal = false"/>
    <ConfirmationModal v-if="this.isFull || confirmModal" :message="confirmMessage" confirmBtn="Yes" cancleBtn="No"
                       @close-modal="confirmModalHandler($event)"/>
</template>

<script>
    import roles from '../../../api-services/roles';
    import AlartModal from "../../components/AlartModal";
    import changeHandler from "../../../validation/organizationValidation";
    import {computed} from "vue";
    import ConfirmationModal from "../../components/ConfirmationModal";
    import capitalizeFirstLetter from "../../../helpers/capitalizeFirstLetter";
    export default {
        name:'role-edit',
        data(){
            return{
                isErrorNumberExist:false,
                errorMsg:'',
                isRoleCreatedSuccessfully:false,
                changeHandler,
                capitalizeFirstLetter,
                permissions:[],
                addPermissions:[],
                editPermissions:[],
                deletePermissions:[],
                viewPermissions:[],
                selectedRoles:[],
                error: null,
                type:'plateform',
                state: false,
                ImagePath:'',
                showModal:false,
                message:null,
                role:{
                    name:null,
                    permissionsInputs:[]
                },
                errors:{
                    name:[],
                    isError: false
                },
                errorMessages:[],
                responseErrorMessage:'',
                showErrorModal:false,
                isFull: false,
                isDataFlag: computed(() => this.$store.state.settings.setDataFlag),
                isData:{
                    name: false,
                },
                confirmModal: computed(() => this.$store.state.settings.confirmModal),
                confirmMessage: computed(() => this.$store.state.settings.confirmMessage)
            }
        },
        components:{
            AlartModal,
            ConfirmationModal
        },
        mounted(){
            this.getPermissions();
            this.showPermission();
        },
        methods:{
            checkNumberInInputs(e) {
                this.errors.name = [];
                const regex = /\d/;
                if(e.target.value === ''){
                    this.isErrorNumberExist = true;
                    this.errorMsg = '*Required';
                }
                else if(!isNaN(e.target.value) || regex.test(e.target.value)){
                    this.isErrorNumberExist = true;
                    this.errorMsg = '*Role name must be letters only';
                    this.isRoleCreatedSuccessfully = true;
                }else{
                    this.isErrorNumberExist = false;
                    this.isRoleCreatedSuccessfully = false;
                    this.errorMsg = '';
                }
            },
            checkPermissionAdd(e , value){
                if(e.target.checked === true){
                    let data = value.split(" ");
                    this.viewPermissions.forEach(item => {
                        if(item.name === 'viewAny '+data[1]){
                            this.role.permissionsInputs.push(item.id);
                        }
                    });
                }else{
                    let data = value.split(" ");
                    this.viewPermissions.forEach(item => {
                        if(item.name === 'viewAny '+data[1]){
                            let idx = this.role.permissionsInputs.indexOf(item.id);
                            this.role.permissionsInputs.splice(idx , 1);
                        }
                    });
                }
            },
            checkPermissionEdit(e , value){
                if(e.target.checked === true){
                    let data = value.split(" ");
                    this.viewPermissions.forEach(item => {
                        if(item.name === 'viewAny '+data[1]){
                            this.role.permissionsInputs.push(item.id);
                        }
                    });
                }else{
                    let data = value.split(" ");
                    this.viewPermissions.forEach(item => {
                        if(item.name === 'viewAny '+data[1]){
                            let idx = this.role.permissionsInputs.indexOf(item.id);
                            this.role.permissionsInputs.splice(idx , 1);
                        }
                    });
                }
            },
            checkPermissionDelete(e , value){
                if(e.target.checked === true){
                    let data = value.split(" ");
                    this.viewPermissions.forEach(item => {
                        if(item.name === 'viewAny '+data[1]){
                            this.role.permissionsInputs.push(item.id);
                        }
                    });
                }else{
                    let data = value.split(" ");
                    this.viewPermissions.forEach(item => {
                        if(item.name === 'viewAny '+data[1]){
                            let idx = this.role.permissionsInputs.indexOf(item.id);
                            this.role.permissionsInputs.splice(idx , 1);
                        }
                    });
                }
            },
            async backHandler () {
                let setDataFlag = this.$store.state.settings.setDataFlag;
                if(setDataFlag){
                    this.isFull = true;
                    await this.$store.dispatch('setConfirmMessage', 'Are you sure you want to go back and remove all data?');
                }else {
                    await this.$store.dispatch('setDataFlag', false);
                    this.isFull = false
                }
            },
            setData(e, type) {
                let val = e.target.value;
                if (type === 'name') {
                    if (val !== null) {
                        this.isData.name = true;
                    } else {
                        this.isData.name = false;
                    }
                }

                if (this.isData.name) {
                    this.$store.dispatch('setDataFlag', true);
                    console.log('data ==>> ')
                } else {
                    this.$store.dispatch('setDataFlag', false);
                    console.log('no data ==>> ');
                }
            },
            async confirmModalHandler (event) {
                this.isFull = false;
                await this.$store.dispatch('setConfirmModal', false);
                if(event){
                    await this.$store.dispatch('setDataFlag', false);
                    await this.$router.push('/roles');
                }
            },
            async getPermissions(){
                try{
                    const response = await roles.getPermissions(this.type);

                    this.permissions = response.data.data;
                    this.addPermissions = response.data.data;
                    this.editPermissions = response.data.data;
                    this.deletePermissions = response.data.data;
                    this.viewPermissions = response.data.data;

                    let filteredData1 = this.permissions.filter(function (data) {
                        return data.category === 'add';
                    });
                    this.addPermissions = filteredData1;

                    let filteredData2 = this.permissions.filter(function (data) {
                        return data.category === 'edit';
                    });
                    this.editPermissions = filteredData2;

                    let filteredData3 = this.permissions.filter(function (data) {
                        return data.category === 'delete';
                    });
                    this.deletePermissions = filteredData3;

                    let filteredData4 = this.permissions.filter(function (data) {
                        return data.category === 'view';
                    });

                    filteredData4.map((item) => {
                        let elm = item.name.split(' ')[0];
                        if (elm === 'viewAny')
                            item.name = item.name.replace('viewAny', 'view')
                    });
                    this.viewPermissions = filteredData4;
                }catch(e){
                    console.log(e);
                }
            },
            async showPermission(){
                try{
                    const role_id = this.$route.params.id;
                    const response = await roles.show(role_id);
                    this.role.name = response.data.data.name.replace(' super_admin' , '');
                    // this.role.permissionsInputs = response.data.data.permission;
                    for(let j = 0 ; j < response.data.data.permission.length ; j++){
                        this.role.permissionsInputs.push(response.data.data.permission[j].id);
                    }

                    console.log(this.role.permissionsInputs);

                    for (let i = 0 ; i < this.role.permissionsInputs.length ; i++){
                        this.selectedRoles.push(this.role.permissionsInputs[i].id);
                    }

                }catch(e){
                    console.log(e);
                }
            },
            async EditRole(){
                try{
                    if(this.isRoleCreatedSuccessfully){
                        console.log('error');
                    }else if(this.role.name == null || this.role.name === '' || this.role.permissionsInputs.length < 1){
                        this.showModal = true;
                        this.ImagePath = 'close.png';
                        this.message = 'Please fill fata correctly';

                        if (this.role.name === null || this.role.name === '') {
                            this.errors.isError = true;
                            this.errors['name'][0] = '*Required';
                            this.isErrorNumberExist = false;
                        }
                    }else if(this.role.name === 'user' || this.role.name === 'admin' || this.role.name === 'super_admin'){
                        this.showModal = true;
                        this.ImagePath = 'close.png';
                        this.message = 'You Can,t Enter Unique Name';
                    }else {
                        if (!this.errors.isError) {
                            const role_id = this.$route.params.id;
                            const response = await roles.update(role_id, {name : this.role.name + ' super_admin' , permissions:this.role.permissionsInputs});

                            if(response.status === 202){
                                this.showModal = true;
                                this.ImagePath = 'okImage.svg';
                                this.message = "Role Updated Successfully";
                                await this.$store.dispatch('setDataFlag', false);
                                setTimeout(() => {
                                    this.$router.push({name: 'role-index'});
                                } , 1000);
                            }else{
                                console.log('Something Wrong !');
                            }
                        }
                    }
                }catch (e) {
                    if(e.response.data.errors){
                        if(e.response.data.errors.name){
                            if(e.response.data.errors.name)
                                e.response.data.errors.name.forEach((err,idx) => { this.errors['name'][idx] = `* ${err}`});
                        }else{
                            let idx = 0;
                            for (const property in e.response.data.errors) {
                                let record = property.split('.')[0];
                            }
                        }
                    }else if(e.response.data){
                        this.showErrorModal = true;
                        this.ImagePath = 'close.png';
                        this.responseErrorMessage = e.response.data.message
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .notAllowed{
        cursor:not-allowed;
    }

    .form-check-input {
        border: 1px solid #e95626 !important;;
        background-color: transparent !important;
    }

    .form-check-input:checked {
        background-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e") !important;
        border: 2px solid var(--border-color-data-table) !important;;
        background-color: #e95626 !important;
        box-shadow: 0 0 0 1px #e95626 !important;
    }

    .form-check-label{
        text-transform: capitalize;
    }

    ::-webkit-scrollbar {
        width: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: transparent;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #E95626;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #021A24;
    }
    .cssInputDiv p{
        position: relative;
        top: 2px;
    }
    .cssInputDiv{
        border-bottom: 1px solid var(--border-color-data-table);
        padding: 10px;
    }
    input[type=checkbox]{
        background-color: var(--background-color-input-create);
        color: var(--main-color);
        width: 24px;
        height: 22px;
    }
    .cssCardBody{
        background-color: var(--background-color-input-create);
        color: var(--main-color);
        height: 423px;
        overflow-y: auto;
        padding: 0;
    }
    .cssCardHeader{
        background-color: var(--background-color-input-create);
        color: var(--main-color);
        border-bottom:1px solid var(--border-color-data-role) !important;
    }
    .cssCardAll{
        background-color: var(--border-color-data-table) !important;
    }
    .cssInput input{
        width:400px;
        background-color: var(--background-color-input-create);
        color: var(--main-color);
        border-color: var(--border-color-data-table);
    }
    .back-route {
        text-decoration: none;
        cursor: pointer;
        color: #FFF;
        font-size: 22px;
    }

    .back-route:hover {
        color: #FFF;
    }
    #organization_url {
        color: #fff !important;
        background-color: #032431 !important;
    }
    .fourthOrga input{
        background-color: #032431;
        color: #fff;
    }
    .secOrga input{
        background-color: #032431;
        color: #fff;
    }
    .firstOrga input{
        background-color: #032431;
        color:#fff;
    }
    .designBasic{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    .designBasic .createDiv{
        display: flex;
        flex-direction: row;
    }
    .designBasic .createDiv button{
        border:none;
        color:#fff;
        background-color: transparent;
    }
    .buttonSave button{
        border:none;
        color:#fff;
        background-color: var(--btn-bg-color);
        padding: 10px 70px;
        border-radius: 5px;
    }
    .dataFill{
        border: 1px solid var(--border-color-data-table);
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        padding: 23px;
        border-radius: 15px;
        height: calc(100vh - 18vh);
        margin-right: 12px;
        margin-left: -12px;
    }</style>